(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Fix 2026-08-02: '.header_wrapper' bestaat alleen in de header-2/3-varianten.
       Deze shop draait header-1, dus de oude code gooide op élke paginaweergave
       "Cannot read properties of null (reading 'clientHeight')" en zette daardoor
       ook --header-height niet meer. De bottom-nav-variabele blijft bewust
       ongezet als er geen .header_wrapper is: CSS die erop leunt valt dan terug
       op het huidige gedrag. */
    const headerElement = document.getElementById('shopify-section-header');
    if (!headerElement) return;

    document.documentElement.style.setProperty('--header-height', headerElement.clientHeight + 'px');

    const wrapper = headerElement.querySelector('.header_wrapper');
    if (wrapper) {
      document.documentElement.style.setProperty('--header-height-without-bottom-nav', wrapper.clientHeight + 'px');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inkoop-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-inkoop-form]').forEach(function (form) {
  var root = form.closest('.inkoop-form-section');
  var successEl = root.querySelector('[data-success]');
  var errorEl = form.querySelector('[data-form-error]');
  var steps = Array.prototype.slice.call(form.querySelectorAll('.inkoop-form-step'));
  var current = 0;

  var progressFill = form.querySelector('[data-progress-fill]');
  var stepCurrentEl = form.querySelector('[data-step-current]');
  var stepTotalEl = form.querySelector('[data-step-total]');
  var backBtn = form.querySelector('[data-action="back"]');
  var nextBtn = form.querySelector('[data-action="next"]');
  var submitBtn = form.querySelector('[data-action="submit"]');
  var submitBtnDefaultLabel = submitBtn ? submitBtn.textContent : '';

  function isStepVisible(step) {
    var condField = step.getAttribute('data-conditional-field');
    if (!condField) return true;
    var values = (step.getAttribute('data-conditional-values') || '').split('||').map(function (v) { return v.trim(); }).filter(Boolean);
    if (!values.length) return true;
    var el = form.querySelector('[data-field="' + CSS.escape(condField) + '"]');
    var currentValue = el ? (el.value || '').trim() : '';
    return values.indexOf(currentValue) !== -1;
  }

  function visibleSteps() {
    return steps.filter(isStepVisible);
  }

  function updateUI() {
    steps.forEach(function (step, i) {
      step.classList.toggle('is-active', i === current);
    });
    var visible = visibleSteps();
    var pos = visible.indexOf(steps[current]) + 1;
    if (pos === 0) pos = 1;
    if (stepCurrentEl) stepCurrentEl.textContent = String(pos);
    if (stepTotalEl) stepTotalEl.textContent = String(visible.length);
    if (progressFill) progressFill.style.width = ((pos / visible.length) * 100) + '%';
    var isFirstVisible = visible[0] === steps[current];
    var isLastVisible = visible[visible.length - 1] === steps[current];
    if (backBtn) backBtn.style.visibility = isFirstVisible ? 'hidden' : 'visible';
    if (nextBtn) nextBtn.style.display = isLastVisible ? 'none' : 'inline-flex';
    if (submitBtn) submitBtn.style.display = isLastVisible ? 'inline-flex' : 'none';
  }

  function validateStep(index) {
    var step = steps[index];
    var valid = true;
    var firstInvalid = null;

    Array.prototype.forEach.call(step.querySelectorAll('[data-required]'), function (el) {
      var value = (el.value || '').trim();
      if (!value) {
        valid = false;
        el.classList.add('has-error');
        if (!firstInvalid) firstInvalid = el;
      } else {
        el.classList.remove('has-error');
      }
    });

    Array.prototype.forEach.call(step.querySelectorAll('[data-required-group]'), function (group) {
      var key = group.getAttribute('data-checkbox-group');
      var checked = group.querySelectorAll('input[type="checkbox"]:checked');
      var errorEl2 = step.querySelector('[data-error-for-group="' + CSS.escape(key) + '"]');
      if (checked.length === 0) {
        valid = false;
        group.classList.add('has-error');
        if (errorEl2) errorEl2.style.display = 'block';
        if (!firstInvalid) firstInvalid = group;
      } else {
        group.classList.remove('has-error');
        if (errorEl2) errorEl2.style.display = 'none';
      }
    });

    Array.prototype.forEach.call(step.querySelectorAll('[data-required-photo]'), function (input) {
      var key = input.getAttribute('data-photo-field');
      var errorEl3 = step.querySelector('[data-error-for-photo="' + CSS.escape(key) + '"]');
      var count = (input._inkoopFiles || []).length;
      if (count === 0) {
        valid = false;
        if (errorEl3) errorEl3.style.display = 'block';
        if (!firstInvalid) firstInvalid = input;
      } else {
        if (errorEl3) errorEl3.style.display = 'none';
      }
    });

    if (firstInvalid && firstInvalid.scrollIntoView) {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return valid;
  }

  function resizeImage(file, maxDimension, quality) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(url);
        var scale = Math.min(1, maxDimension / Math.max(img.width, img.height));
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        var dataUrl = canvas.toDataURL('image/jpeg', quality);
        resolve(dataUrl.split(',')[1]);
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  function wirePhotoInput(input) {
    input._inkoopFiles = [];
    var scope = input.closest('.inkoop-form-field') || form;
    var preview = scope.querySelector('[data-preview-for="' + CSS.escape(input.getAttribute('data-photo-field')) + '"]');
    input.addEventListener('change', function () {
      var max = parseInt(input.getAttribute('data-max-photos'), 10) || 6;
      var files = Array.prototype.slice.call(input.files).slice(0, max);
      input._inkoopFiles = files;
      if (preview) {
        preview.innerHTML = '';
        files.forEach(function (file) {
          var img = document.createElement('img');
          img.src = URL.createObjectURL(file);
          preview.appendChild(img);
        });
      }
    });
  }

  form.querySelectorAll('[data-photo-field]').forEach(wirePhotoInput);

  // --- Repeatable step groups (e.g. "add another bike") ---
  form.querySelectorAll('[data-repeat-wrap]').forEach(function (wrap) {
    var repeatLabel = wrap.getAttribute('data-repeat-label') || 'Item';
    var maxRepeats = parseInt(wrap.getAttribute('data-max-repeats'), 10) || 5;
    var addBtn = wrap.parentNode.querySelector('[data-action="add-repeat"]');

    function groups() {
      return Array.prototype.slice.call(wrap.querySelectorAll('[data-repeat-group]'));
    }

    function renumber() {
      var list = groups();
      list.forEach(function (group, i) {
        var index = i + 1;
        group.setAttribute('data-repeat-index', String(index));
        var heading = group.querySelector('[data-repeat-heading]');
        if (heading) heading.textContent = repeatLabel + ' ' + index;

        group.querySelectorAll('[data-field]').forEach(function (el) {
          if (!el.dataset.fieldBase) el.dataset.fieldBase = el.getAttribute('data-field').replace(/^.*: /, '');
          el.setAttribute('data-field', repeatLabel + ' ' + index + ': ' + el.dataset.fieldBase);
        });
        group.querySelectorAll('[data-checkbox-group]').forEach(function (el) {
          if (!el.dataset.groupBase) el.dataset.groupBase = el.getAttribute('data-checkbox-group').replace(/^.*: /, '');
          var newKey = repeatLabel + ' ' + index + ': ' + el.dataset.groupBase;
          el.setAttribute('data-checkbox-group', newKey);
          var errEl = group.querySelector('[data-error-for-group]');
          if (errEl) errEl.setAttribute('data-error-for-group', newKey);
        });
        group.querySelectorAll('[data-photo-field]').forEach(function (el) {
          if (!el.dataset.photoBase) el.dataset.photoBase = el.getAttribute('data-photo-field').replace(/^.*: /, '');
          var newKey = repeatLabel + ' ' + index + ': ' + el.dataset.photoBase;
          el.setAttribute('data-photo-field', newKey);
          var preview = group.querySelector('[data-preview-for]');
          if (preview) preview.setAttribute('data-preview-for', newKey);
          var errEl = group.querySelector('[data-error-for-photo]');
          if (errEl) errEl.setAttribute('data-error-for-photo', newKey);
        });

        var removeBtn = group.querySelector('[data-action="remove-repeat"]');
        if (removeBtn) removeBtn.style.display = list.length > 1 ? 'inline-block' : 'none';
      });

      if (addBtn) addBtn.style.display = list.length >= maxRepeats ? 'none' : 'block';
    }

    wrap.addEventListener('click', function (e) {
      var removeBtn = e.target.closest && e.target.closest('[data-action="remove-repeat"]');
      if (removeBtn) {
        var group = removeBtn.closest('[data-repeat-group]');
        if (group && groups().length > 1) group.remove();
        renumber();
      }
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var list = groups();
        if (list.length >= maxRepeats) return;
        var last = list[list.length - 1];
        var clone = last.cloneNode(true);
        clone.querySelectorAll('input[type="text"], input[type="number"], textarea').forEach(function (el) {
          el.value = '';
          el.classList.remove('has-error');
        });
        clone.querySelectorAll('select').forEach(function (el) {
          el.value = '';
          el.classList.remove('has-error');
        });
        clone.querySelectorAll('input[type="checkbox"]').forEach(function (el) { el.checked = false; });
        clone.querySelectorAll('input[type="file"]').forEach(function (el) { el.value = ''; });
        clone.querySelectorAll('[data-preview-for]').forEach(function (el) { el.innerHTML = ''; });
        clone.querySelectorAll('.inkoop-form-field-error').forEach(function (el) { el.style.display = 'none'; });
        last.insertAdjacentElement('afterend', clone);
        clone.querySelectorAll('[data-photo-field]').forEach(wirePhotoInput);
        renumber();
      });
    }

    renumber();
  });

  form.addEventListener('change', updateUI);
  form.addEventListener('input', updateUI);

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (!validateStep(current)) return;
      var next = current + 1;
      while (next < steps.length && !isStepVisible(steps[next])) next += 1;
      if (next < steps.length) {
        current = next;
        updateUI();
      }
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      var prev = current - 1;
      while (prev >= 0 && !isStepVisible(steps[prev])) prev -= 1;
      if (prev >= 0) {
        current = prev;
        updateUI();
      }
    });
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      if (!validateStep(current)) return;
      submitForm();
    });
  }

  function inVisibleStep(el) {
    var stepEl = el.closest('.inkoop-form-step');
    return visibleSteps().indexOf(stepEl) !== -1;
  }

  function submitForm() {
    var webhookUrl = form.getAttribute('data-webhook-url');
    if (!webhookUrl) {
      showError('Formulier is niet geconfigureerd (geen webhook URL).');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Bezig met verzenden…';
    if (errorEl) errorEl.hidden = true;

    var fields = {};
    form.querySelectorAll('[data-field]').forEach(function (el) {
      if (!inVisibleStep(el)) return;
      fields[el.getAttribute('data-field')] = (el.value || '').trim();
    });
    form.querySelectorAll('[data-checkbox-group]').forEach(function (group) {
      if (!inVisibleStep(group)) return;
      var key = group.getAttribute('data-checkbox-group');
      var checked = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]:checked'));
      fields[key] = checked.map(function (el) { return el.value; }).join(', ');
    });

    var photoInputs = Array.prototype.slice.call(form.querySelectorAll('[data-photo-field]')).filter(inVisibleStep);
    var photoPromises = photoInputs.map(function (input) {
      var key = input.getAttribute('data-photo-field');
      var files = input._inkoopFiles || [];
      return Promise.all(files.map(function (file) {
        return resizeImage(file, 1600, 0.82).then(function (base64) {
          return { name: file.name, type: 'image/jpeg', base64: base64 };
        });
      })).then(function (encoded) {
        return { key: key, files: encoded };
      });
    });

    Promise.all(photoPromises).then(function (results) {
      var photos = {};
      results.forEach(function (r) {
        if (r.files.length) photos[r.key] = r.files;
      });

      return fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({ fields: fields, photos: photos })
      });
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      if (!data.ok) throw new Error(data.error || 'Onbekende fout');
      form.hidden = true;
      if (successEl) {
        successEl.hidden = false;
        var numEl = successEl.querySelector('[data-submission-number]');
        if (numEl) numEl.textContent = '#' + data.submissionNumber;

        var dateEl = successEl.querySelector('[data-submission-date]');
        if (dateEl) {
          var now = new Date();
          var dd = ('0' + now.getDate()).slice(-2);
          var mm = ('0' + (now.getMonth() + 1)).slice(-2);
          dateEl.textContent = dd + '-' + mm + '-' + now.getFullYear();
        }

        var roleEl = successEl.querySelector('[data-submission-role]');
        if (roleEl) roleEl.textContent = fields['Welke rol heb jij? (naam)'] || '-';
      }
    }).catch(function (err) {
      showError('Er ging iets mis bij het verzenden: ' + err.message + '. Probeer het opnieuw.');
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtnDefaultLabel;
    });
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  updateUI();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proefrit-planner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MONTHS = [
    'januari', 'februari', 'maart', 'april', 'mei', 'juni',
    'juli', 'augustus', 'september', 'oktober', 'november', 'december'
  ];
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function ymd(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function toMinutes(value) {
    var parts = String(value || '').split(':');
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    if (isNaN(h) || isNaN(m)) return null;
    return h * 60 + m;
  }

  function toTime(total) {
    return pad(Math.floor(total / 60)) + ':' + pad(total % 60);
  }

  function initPlanner(root) {
    if (root.dataset.plannerReady) return;
    root.dataset.plannerReady = 'true';

    var openDays = (root.getAttribute('data-open-days') || '')
      .split(',')
      .map(function (v) { return parseInt(v, 10); })
      .filter(function (v) { return !isNaN(v); });

    var blocked = (root.getAttribute('data-blocked-dates') || '')
      .split(',')
      .map(function (v) { return v.trim(); })
      .filter(Boolean);

    var slotStart = toMinutes(root.getAttribute('data-slot-start'));
    var slotEndTime = toMinutes(root.getAttribute('data-slot-end'));
    var slotStartSunday = toMinutes(root.getAttribute('data-slot-start-sunday'));
    var slotInterval = parseInt(root.getAttribute('data-slot-interval'), 10) || 60;
    var monthsAhead = parseInt(root.getAttribute('data-months-ahead'), 10) || 3;
    var webhookUrl = root.getAttribute('data-webhook-url');

    if (slotStart === null || slotEndTime === null || slotEndTime <= slotStart) {
      slotStart = 12 * 60;
      slotEndTime = 16 * 60;
    }

    var monthLabel = root.querySelector('[data-cal-month]');
    var daysWrap = root.querySelector('[data-cal-days]');
    var prevBtn = root.querySelector('[data-cal-prev]');
    var nextBtn = root.querySelector('[data-cal-next]');
    var slotsLabel = root.querySelector('[data-slots-label]');
    var slotsGrid = root.querySelector('[data-slots]');
    var hint = root.querySelector('[data-step1-hint]');
    var toStep2 = root.querySelector('[data-to-step2]');
    var toStep1 = root.querySelector('[data-to-step1]');
    var chosen = root.querySelector('[data-chosen]');
    var submitBtn = root.querySelector('[data-submit]');
    var formError = root.querySelector('[data-form-error]');
    var successWhen = root.querySelector('[data-success-when]');
    var successNumber = root.querySelector('[data-success-number]');
    var steps = root.querySelectorAll('[data-step]');

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var viewYear = today.getFullYear();
    var viewMonth = today.getMonth();
    var selectedDate = null;
    var selectedSlot = null;

    var lastAllowed = new Date(today.getFullYear(), today.getMonth() + monthsAhead + 1, 0);

    function isSelectable(date) {
      if (date < today || date > lastAllowed) return false;
      if (openDays.indexOf(date.getDay()) === -1) return false;
      if (blocked.indexOf(ymd(date)) !== -1) return false;
      return true;
    }

    function longDate(date) {
      return DAYS[date.getDay()] + ' ' + date.getDate() + ' ' + MONTHS[date.getMonth()];
    }

    // We bewaren alleen de begintijd; het einde volgt uit de lengte van het
    // tijdvak. Zo blijft de kolom in de Sheet sorteerbaar.
    function slotEnd(start) {
      return toTime(toMinutes(start) + slotInterval);
    }

    function slotRange(start) {
      return start + ' - ' + slotEnd(start);
    }

    function renderCalendar() {
      monthLabel.textContent = MONTHS[viewMonth] + ' ' + viewYear;
      daysWrap.innerHTML = '';

      var first = new Date(viewYear, viewMonth, 1);
      var lead = (first.getDay() + 6) % 7;
      var total = new Date(viewYear, viewMonth + 1, 0).getDate();
      var i;

      for (i = 0; i < lead; i++) {
        var filler = document.createElement('span');
        filler.className = 'proefrit-planner-day proefrit-planner-day--empty';
        daysWrap.appendChild(filler);
      }

      for (i = 1; i <= total; i++) {
        var date = new Date(viewYear, viewMonth, i);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'proefrit-planner-day';
        btn.textContent = String(i);
        btn.setAttribute('data-date', ymd(date));

        if (date.getTime() === today.getTime()) {
          btn.classList.add('is-today');
        }

        if (isSelectable(date)) {
          btn.setAttribute('aria-label', longDate(date));
        } else {
          btn.disabled = true;
          btn.setAttribute('aria-label', longDate(date) + ', niet beschikbaar');
        }

        daysWrap.appendChild(btn);
      }

      prevBtn.disabled = viewYear === today.getFullYear() && viewMonth === today.getMonth();
      nextBtn.disabled = new Date(viewYear, viewMonth + 1, 1) > lastAllowed;

      markSelectedDay();
    }

    // De tijdvakken zijn elke dag gelijk, dus deze lijst bouwen we een keer.
    // Zo kan iemand ook eerst een tijd kiezen en daarna pas een dag.
    function renderSlots() {
      slotsGrid.innerHTML = '';

      for (var m = slotStart; m + slotInterval <= slotEndTime; m += slotInterval) {
        var time = toTime(m);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'proefrit-planner-slot';
        btn.textContent = slotRange(time);
        btn.setAttribute('data-time', time);
        slotsGrid.appendChild(btn);
      }
    }

    // Op zondag begint het aanbod later. De lijst blijft hetzelfde; vroege
    // tijdvakken worden verborgen en een al gekozen vroege tijd wordt gewist.
    function applySlotAvailability() {
      var sunday = Boolean(selectedDate && selectedDate.getDay() === 0 && slotStartSunday !== null);
      slotsGrid.querySelectorAll('[data-time]').forEach(function (el) {
        el.hidden = sunday && toMinutes(el.getAttribute('data-time')) < slotStartSunday;
      });
      if (selectedSlot && sunday && toMinutes(selectedSlot) < slotStartSunday) {
        selectedSlot = null;
        markSelectedSlot();
      }
    }

    // Alleen klassen omzetten in plaats van opnieuw opbouwen: een dagklik ging
    // anders over 36 knoppen heen en dat was merkbaar traag.
    function markSelected(elements, attribuut, waarde) {
      elements.forEach(function (el) {
        var isSelected = waarde !== null && el.getAttribute(attribuut) === waarde;
        el.classList.toggle('is-selected', isSelected);
        if (isSelected) {
          el.setAttribute('aria-pressed', 'true');
        } else {
          el.removeAttribute('aria-pressed');
        }
      });
    }

    function markSelectedDay() {
      markSelected(daysWrap.querySelectorAll('[data-date]'), 'data-date', selectedDate ? ymd(selectedDate) : null);
    }

    function markSelectedSlot() {
      markSelected(slotsGrid.querySelectorAll('[data-time]'), 'data-time', selectedSlot);
    }

    function updateSlotsLabel() {
      slotsLabel.textContent = selectedDate ? longDate(selectedDate) : 'Hoe laat?';
    }

    function updateStep1() {
      var compleet = Boolean(selectedDate && selectedSlot);

      // De knop verschijnt pas als dag en tijd allebei gekozen zijn.
      toStep2.hidden = !compleet;
      toStep2.disabled = !compleet;

      // Pas vragen om de andere helft zodra er iets gekozen is. Aan het begin
      // spreken de kalender en de tijdkolom voor zich.
      if (selectedDate && !selectedSlot) {
        hint.textContent = 'Kies nog een tijd.';
      } else if (selectedSlot && !selectedDate) {
        hint.textContent = 'Kies nog een dag.';
      } else {
        hint.textContent = '';
      }
    }

    function showStep(n) {
      steps.forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-step') === String(n));
      });
    }

    daysWrap.addEventListener('click', function (event) {
      var btn = event.target.closest('.proefrit-planner-day');
      if (!btn || btn.disabled) return;
      var parts = btn.getAttribute('data-date').split('-');
      selectedDate = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      // Een al gekozen tijd blijft staan, behalve als die op zondag te vroeg is.
      applySlotAvailability();
      markSelectedDay();
      updateSlotsLabel();
      updateStep1();
    });

    slotsGrid.addEventListener('click', function (event) {
      var btn = event.target.closest('.proefrit-planner-slot');
      if (!btn) return;
      selectedSlot = btn.getAttribute('data-time');
      markSelectedSlot();
      updateStep1();
    });

    prevBtn.addEventListener('click', function () {
      viewMonth -= 1;
      if (viewMonth < 0) { viewMonth = 11; viewYear -= 1; }
      renderCalendar();
    });

    nextBtn.addEventListener('click', function () {
      viewMonth += 1;
      if (viewMonth > 11) { viewMonth = 0; viewYear += 1; }
      renderCalendar();
    });

    toStep2.addEventListener('click', function () {
      if (!selectedDate || !selectedSlot) return;
      chosen.textContent = 'Uw proefrit: ' + longDate(selectedDate) + ', ' + slotRange(selectedSlot) + ' uur.';
      showStep(2);
    });

    toStep1.addEventListener('click', function () {
      showStep(1);
    });

    function fieldValue(name) {
      var input = root.querySelector('[data-field="' + name + '"]');
      return input ? input.value.trim() : '';
    }

    function setFieldError(name, hasError) {
      var input = root.querySelector('[data-field="' + name + '"]');
      var error = root.querySelector('[data-error-for="' + name + '"]');
      if (input) input.classList.toggle('has-error', hasError);
      if (error) error.hidden = !hasError;
    }

    function validate() {
      var naamOk = fieldValue('naam').length > 1;
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(fieldValue('email'));
      var telOk = fieldValue('telefoon').replace(/[^0-9]/g, '').length >= 9;

      setFieldError('naam', !naamOk);
      setFieldError('email', !emailOk);
      setFieldError('telefoon', !telOk);

      return naamOk && emailOk && telOk;
    }

    submitBtn.addEventListener('click', function () {
      formError.hidden = true;
      if (!validate()) return;

      if (!webhookUrl) {
        formError.hidden = false;
        formError.textContent = 'Dit formulier is nog niet gekoppeld. Bel ons even, dan plannen we de proefrit samen in.';
        return;
      }

      var originalLabel = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Bezig met versturen...';

      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          datum: ymd(selectedDate),
          datum_lang: longDate(selectedDate),
          tijd: selectedSlot,
          tijd_tot: slotEnd(selectedSlot),
          naam: fieldValue('naam'),
          email: fieldValue('email'),
          telefoon: fieldValue('telefoon'),
          locatie: root.getAttribute('data-location') || '',
          pagina: window.location.href
        })
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        // Apps Script antwoordt altijd met status 200, dus we kijken naar het veld ok.
        if (!data || !data.ok) throw new Error((data && data.error) || 'Onbekende fout');
        successWhen.textContent = longDate(selectedDate) + ', ' + slotRange(selectedSlot) + ' uur';
        if (data.boekingsnummer) {
          successNumber.hidden = false;
          successNumber.textContent = 'Boekingsnummer: ' + data.boekingsnummer;
        }
        showStep(3);
      }).catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        formError.hidden = false;
        formError.textContent = 'Het versturen is niet gelukt. Probeer het nog een keer, of bel ons even - dan zetten we de afspraak voor u klaar.';
      });
    });

    renderSlots();
    renderCalendar();
    updateSlotsLabel();
    updateStep1();
  }

  document.querySelectorAll('[data-proefrit-planner]').forEach(initPlanner);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.reviews-slider-section').forEach(function (root) {
  var track = root.querySelector('[data-track]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');
  if (!track) return;

  function cardStep() {
    var card = track.querySelector('.reviews-slider-card');
    if (!card) return 300;
    var style = window.getComputedStyle(track);
    var gap = parseInt(style.columnGap || style.gap || '20', 10) || 20;
    return card.getBoundingClientRect().width + gap;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
